@if (isLoading) {
  <div class="loading-overlay">
    <div class="loading-content">
      <p-progressSpinner strokeWidth="4" animationDuration=".5s" ></p-progressSpinner>
    </div>
  </div>
}